import { create } from 'zustand'
import { CanalComercial } from '@/types/statusReserva'

/**
 * Slice do canal comercial selecionado globalmente (Onda 1 / A02, decisão 6.7).
 *
 * Alimenta o SeletorCanalGlobal do back-office (ADMIN/GERENTE): `''` significa
 * "Todos os canais". Estado de UI apenas — o recorte de verdade acontece no
 * backend, que ignora o parâmetro para quem não pode desescopar.
 */
export interface CanalStore {
  canal: '' | CanalComercial
  setCanal: (canal: '' | CanalComercial) => void
}

export const canalStore = create<CanalStore>((set) => ({
  canal: '',
  setCanal: (canal) => set({ canal }),
}))
